import { writable } from 'svelte/store';

export const nearestStationsMeteoStore = writable([]);